import { formatPhoneToApi, getAddress, getDOBFormatted } from 'src/utils';
import type { IApiContactPerson, IContactPersonFilled } from 'src/interfaces';

export const mapContactPersonToApi = ({
  address,
  apartment,
  dateOfBirth,
  email,
  firstName,
  lastName,
  phone,
}: IContactPersonFilled): IApiContactPerson => {
  const trimmedApartment = apartment.trim();

  return {
    address: {
      ...address,
      ...(trimmedApartment ? { room: trimmedApartment } : null),
      formatted_address: getAddress(address, trimmedApartment),
    },
    date_of_birth: getDOBFormatted(dateOfBirth),
    email: email.trim(),
    firstname: firstName.trim(),
    lastname: lastName.trim(),
    phone: formatPhoneToApi(phone),
  };
};
